export const isShadowRoot = (
    isWidgetShadowRootEnabled: boolean | null,
    isGlobalShadowRootDisabled: boolean
): boolean => {
    if (isWidgetShadowRootEnabled !== null) return isWidgetShadowRootEnabled;

    return !isGlobalShadowRootDisabled;
};
